import req from 'shared/req';

export const fetchUniversities = (educationPhases) => () =>
  req({
    url: `/v1/lists/partners${
      educationPhases ? `?educationPhases=${educationPhases.join(',')}` : ''
    }`,
  });

export const fetchSlugForUniversity = (universityId) =>
  req({
    url: '/v1/colleges',
    data: {
      'university-ids': universityId,
      fields: 'slug',
      limit: 1,
    },
  }).then((response) => response[0].slug);

export const fetchScholarshipPrograms = (educationPhase, universityId) => () =>
  req({
    url: '/v1/scholarship-programs?fields=_id,name',
    data: {
      educationPhase,
      universityId,
    },
  });
